"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M17.6471 0H2.35294C1.72948 0.00186203 1.13208 0.250358 0.691217 0.691217C0.250358 1.13208 0.00186203 1.72948 0 2.35294L0 17.6471C0.00186203 18.2705 0.250358 18.8679 0.691217 19.3088C1.13208 19.7496 1.72948 19.9981 2.35294 20H11.1106V13.9529H9.04353V11.2588H11.1106V9.90588C11.0919 9.43145 11.1681 8.95806 11.3348 8.51348C11.5015 8.0689 11.7552 7.66209 12.0813 7.31691C12.4073 6.97172 12.7989 6.69512 13.2333 6.50332C13.6676 6.31153 14.1359 6.2084 14.6106 6.2H16.5153V9.23529H14.8106C14.7293 9.22525 14.6469 9.23449 14.5699 9.26225C14.4929 9.29002 14.4235 9.33553 14.3673 9.39511C14.3112 9.45469 14.2699 9.52665 14.2467 9.60517C14.2236 9.68369 14.2193 9.76656 14.2341 9.84706V11.2588H16.5153V13.9529H14.2353V20H17.6471C18.2705 19.9981 18.8679 19.7496 19.3088 19.3088C19.7496 18.8679 19.9981 18.2705 20 17.6471V2.35294C19.9981 1.72948 19.7496 1.13208 19.3088 0.691217C18.8679 0.250358 18.2705 0.00186203 17.6471 0V0Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;